import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableDataSetComponent } from './table-data-set.component';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { NgScrollbar } from 'ngx-scrollbar';
import { TableCellRenderPipe } from './table-data-set-render.pipe';
import { TableDataSetDisablePipe } from './table-data-set-disable.pipe';
import { NgxVisibilityModule } from 'ngx-visibility';
import { TableDataSetLinkPipe } from './table-data-set-link.pipe';
import { RouterLink } from '@angular/router';
import { FilterDataSetModule } from '../filter-data-set';
import { TableDataSetMiddleRenderPipe } from './table-data-set-middle-render.pipe';
import { TableDataSetMiddleClassPipe } from './table-data-set-middle-class.pipe';
import { TableDataSetOnlyIconPipe } from './table-data-set-only-icon.pipe';


@NgModule({
  declarations: [
    TableDataSetComponent,
    TableCellRenderPipe,
    TableDataSetDisablePipe,
    TableDataSetLinkPipe,
    TableDataSetMiddleRenderPipe,
    TableDataSetMiddleClassPipe,
    TableDataSetOnlyIconPipe
  ],
  exports: [
    TableDataSetComponent,
    TableDataSetDisablePipe,
    TableDataSetLinkPipe,
    TableCellRenderPipe,
    TableDataSetMiddleRenderPipe,
    TableDataSetMiddleClassPipe,
    TableDataSetOnlyIconPipe
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTableModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    NgScrollbar,
    MatRippleModule,
    NgxVisibilityModule,
    RouterLink,
    FilterDataSetModule
  ]
})
export class TableDataSetModule {
}
